/*
  Scroll-Geometrie des Rasters — bewusst ohne DOM und React, damit die Rechnung
  testbar bleibt. Gemessen wird in ShiftplanMonthGrid.
*/

/*
  Wie weit muss der Container auf einer Achse scrollen, damit das Ziel frei liegt?

  Alle Werte gehören zur selben Achse und zum selben Bezugssystem (z. B.
  Viewport-Koordinaten aus getBoundingClientRect). `viewStart`/`viewEnd`
  beschreiben den *nutzbaren* Bereich: die klebende Kopfzeile bzw. die klebende
  Namensspalte sind dort schon abgezogen, denn ein Ziel darunter wäre formal
  sichtbar, aber verdeckt.

  Rückgabe ist die Verschiebung, die auf scrollLeft/scrollTop addiert wird. 0
  heisst "liegt schon frei, nicht scrollen". Es wird immer nur so weit gescrollt
  wie nötig — das hält die Bewegung klein, wenn man eine nach Datum sortierte
  Liste von Zielen der Reihe nach überfährt.
*/
export function getRevealDelta({ viewStart, viewEnd, targetStart, targetEnd, margin = 0 } = {}) {
  const start = Number(viewStart);
  const end = Number(viewEnd);
  const from = Number(targetStart);
  const to = Number(targetEnd);
  if (![start, end, from, to].every(Number.isFinite)) return 0;

  const available = end - start;
  if (available <= 0) return 0;

  // Der Rand darf den nutzbaren Bereich nie aufbrauchen: bei einem Ziel, das
  // fast so gross ist wie der Bereich, schrumpft er auf 0.
  const targetSize = Math.max(0, to - from);
  const padding = Math.max(0, Math.min(Number(margin) || 0, (available - targetSize) / 2));
  const minStart = start + padding;
  const maxEnd = end - padding;

  if (from < minStart) return from - minStart;
  // Passt das Ziel nicht in den Bereich, hat sein Anfang Vorrang.
  if (to > maxEnd) return Math.min(to - maxEnd, from - minStart);
  return 0;
}
